import { observable } from "mobx";
import type { EntityValidationRules } from "../services/validationService";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class ChangeEmailRequest {
  /**
   * New e-mail that should replace the old one.
   * @example
   * test@email.com
   */
  @observable
  newEmail!: string;

  /**
   * Official e-mail change record ID.
   * @example
   * ASD-654321/2021
   */
  @observable
  officialRecordId!: string;
}

export const ChangeEmailRequestValidationRules: EntityValidationRules<ChangeEmailRequest> = {
  newEmail: {
    required: true,
    isEmail: { required: true },
  },
  officialRecordId: {
    required: true,
    isLength: {
      min: 3,
      max: 50,
    },
  },
};
